<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'CurrencyManagement'
};
</script>

<style lang="less" scoped></style>